import { createSlice } from '@reduxjs/toolkit';

export const defaultLecturersListFilter = {
    firstName: "",
    lastName: "",
    isActive: false,
}
const initialState = {
    lecturersListFilter: defaultLecturersListFilter,
    allLecturers: [],
    loading: false,
    error: null,
};

const lecturersSlice = createSlice({
    name: 'lecturers',
    initialState,
    reducers: {
        setAllLecturers: (state, action) => {
            state.allLecturers = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setLecturersListFilter: (state, action) => {
            state.lecturersListFilter = action.payload ? action.payload : defaultLecturersListFilter;
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllLecturers, setLecturersListFilter } = lecturersSlice.actions;

export default lecturersSlice.reducer;